import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { validateEmail, validatePhoneNumber } from '../../ValidateFunctions';
import PhoneNumberInput from '../FormInputs/PhoneNumberInput';
import TextInput from '../FormInputs/TextInput';
import FormTitle from '../FormTitle';

StaffInfoInputs.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
  isEditable: PropTypes.bool,
};

export default function StaffInfoInputs({ fieldName, focusedField, setFocusedField, fieldAttributes, isEditable }) {
  const { control } = useFormContext();

  return (
    <Grid container spacing={1}>
      <Controller
        name={`${fieldName}.firstName`}
        control={control}
        render={() => (
          <Grid item xs={12} sm={6} lg={3}>
            <FormTitle fieldAttributes={{ questionTitle: 'First name' }} />
            <TextInput
              fieldName={`${fieldName}.firstName`}
              focusedField={focusedField}
              setFocusedField={setFocusedField}
              fieldAttributes={{ ...fieldAttributes, isEditable }}
              multiline={false}
            />
          </Grid>
        )}
      />
      <Controller
        name={`${fieldName}.lastName`}
        control={control}
        render={() => (
          <Grid item xs={12} sm={6} lg={3}>
            <FormTitle fieldAttributes={{ questionTitle: 'Last name' }} />
            <TextInput
              fieldName={`${fieldName}.lastName`}
              focusedField={focusedField}
              setFocusedField={setFocusedField}
              fieldAttributes={{ ...fieldAttributes, isEditable }}
              multiline={false}
            />
          </Grid>
        )}
      />
      <Controller
        name={`${fieldName}.cellPhone`}
        control={control}
        rules={{
          validate: (value) => validatePhoneNumber(value),
        }}
        render={() => (
          <Grid item xs={12} sm={6} lg={3}>
            <FormTitle fieldAttributes={{ questionTitle: 'Cell phone' }} />
            <PhoneNumberInput
              fieldName={`${fieldName}.cellPhone`}
              focusedField={focusedField}
              setFocusedField={setFocusedField}
              fieldAttributes={{ ...fieldAttributes, isEditable }}
            />
          </Grid>
        )}
      />
      <Controller
        name={`${fieldName}.email`}
        control={control}
        rules={{
          pattern: validateEmail,
        }}
        render={() => (
          <Grid item xs={12} sm={6} lg={3}>
            <FormTitle fieldAttributes={{ questionTitle: 'Email' }} />
            <TextInput
              fieldName={`${fieldName}.email`}
              focusedField={focusedField}
              setFocusedField={setFocusedField}
              fieldAttributes={{ ...fieldAttributes, isEditable }}
              multiline={false}
            />
          </Grid>
        )}
      />
    </Grid>
  );
}
